module.exports = __webpack_public_path__ + "media/ecu/bghead-2d380f6e.png";